<template>
  <div>
    <section class="back-section">
      <div class="dashboard-container">
        <div class="d-flex  flex-column align-items-center">
          <h2>
            總銷量
          </h2>
          <Chart :chartData="totalData"></Chart>
        </div>
        <div class="d-flex  flex-column align-items-center">
          <h2>
            平面設計銷量
          </h2>
          <Chart :chartData="designTotalData"></Chart>
        </div>
        <div class="d-flex  flex-column align-items-center">
          <h2>
            系統設計銷量
          </h2>
          <Chart :chartData="systemTotalData"></Chart>
        </div>
        <div class="d-flex  flex-column align-items-center">
          <h2>
            網頁設計銷量
          </h2>
          <Chart :chartData="webTotalData"></Chart>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ordersRequest from '@/assets/js/api/back/apiOrder';
import Chart from './components/Chart';
import { mapState } from 'vuex';
export default {
  created() {
    this.creatData();
  },
  data() {
    return {
      orderData: [],
      total: '',
      webTotal: '',
      systemTotal: '',
      designTotal: '',
    };
  },
  components: {
    Chart,
  },
  computed: {
    ...mapState(['user']),
    totalData() {
      return {
        columns: ['總數', '平面設計', '系統設計', '網頁設計'],
        rows: [
          {
            總數: this.total,
            平面設計: this.designTotal,
            系統設計: this.systemTotal,
            網頁設計: this.webTotal,
          },
        ],
      };
    },
    designTotalData() {
      let data = this.orderData.filter(item => {
        return item.category === '平面設計';
      });
      let menu = data.reduce((old, cur) => {
        if (cur.title === 'MENU設計') {
          return old + cur.quantity;
        }
        return old;
      }, 0);
      let card = data.reduce((old, cur) => {
        if (cur.title === '名片設計') {
          return old + cur.quantity;
        }
        return old;
      }, 0);
      return {
        columns: ['總數', 'MENU設計', '名片設計'],
        rows: [
          {
            總數: this.designTotal,
            MENU設計: menu,
            名片設計: card,
          },
        ],
      };
    },
    systemTotalData() {
      let data = this.orderData.filter(item => {
        return item.category === '系統設計';
      });
      let admin = data.reduce((old, cur) => {
        if (cur.title === '後台管理系統設計') {
          return old + cur.quantity;
        }
        return old;
      }, 0);
      let reservation = data.reduce((old, cur) => {
        if (cur.title === '預約系統設計') {
          return old + cur.quantity;
        }
        return old;
      }, 0);
      return {
        columns: ['總數', '後台管理系統設計', '預約系統設計'],
        rows: [
          {
            總數: this.systemTotal,
            後台管理系統設計: admin,
            預約系統設計: reservation,
          },
        ],
      };
    },
    webTotalData() {
      let data = this.orderData.filter(item => {
        return item.category === '網頁設計';
      });
      let store = data.reduce((old, cur) => {
        if (cur.title === '電商網站設計') {
          return old + cur.quantity;
        }
        return old;
      }, 0);
      let event = data.reduce((old, cur) => {
        if (cur.title === '活動網站設計') {
          return old + cur.quantity;
        }
        return old;
      }, 0);
      let landingPage = data.reduce((old, cur) => {
        if (cur.title === '一頁式網站設計') {
          return old + cur.quantity;
        }
        return old;
      }, 0);
      return {
        columns: ['總數', '活動網站設計', '電商網站設計', '一頁式網站設計'],
        rows: [
          {
            總數: this.webTotal,
            活動網站設計: event,
            電商網站設計: store,
            一頁式網站設計: landingPage,
          },
        ],
      };
    },
  },
  methods: {
    creatData() {
      ordersRequest.defaults.headers.common.Authorization = `Bearer ${this.user.token}`;
      ordersRequest
        .get('')
        .then(response => {
          response.data.data
            .map(data => {
              return data.products;
            })
            .forEach(item1 => {
              item1.forEach(item2 => {
                this.orderData.push({
                  ...item2.product,
                  quantity: item2.quantity,
                });
              });
            });
          this.total = this.orderData.reduce((old, crr) => {
            return old + crr.quantity;
          }, 0);
          this.systemTotal = this.orderData.reduce((old, crr) => {
            if (crr.category === '系統設計') {
              return old + crr.quantity;
            }
            return old;
          }, 0);
          this.designTotal = this.orderData.reduce((old, crr) => {
            if (crr.category === '平面設計') {
              return old + crr.quantity;
            }
            return old;
          }, 0);
          this.webTotal = this.orderData.reduce((old, crr) => {
            if (crr.category === '網頁設計') {
              return old + crr.quantity;
            }
            return old;
          }, 0);
        })
        .catch(err => {
          this.$fire({
            title: `${err}`,
            type: 'error',
            timer: 3000,
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
